import { InjectionToken } from '@angular/core';
import { type AuthTokenService } from './auth-token-service.interface';

export const AUTH_TOKEN_SERVICE = new InjectionToken<AuthTokenService>('AUTH_TOKEN_SERVICE');
